import { UserPlus } from 'lucide-react';
import { ChecklistBoard } from './components/ChecklistBoard';

const OnboardingPage = () => (
  <ChecklistBoard
    kind="onboarding"
    title="Onboarding"
    description="Checklists for every new hire — paperwork, equipment, access, and training."
    crumbLabel="Onboarding"
    icon={UserPlus}
  />
);

export default OnboardingPage;
